/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectAutoparksContainerDomain = state => state.autoparksContainerReducer || initialState;

export const getIsAutoparksLoadingSelector = () =>
	createSelector(selectAutoparksContainerDomain, ({ isAutoparksLoading }) => isAutoparksLoading);

export const getAutoparksSelector = () =>
	createSelector(selectAutoparksContainerDomain, ({ autoparks }) => {
		if (!autoparks || autoparks.length === 0) {
			return [];
		}

		return autoparks;
	});

export const getPaginationSelector = () =>
	createSelector(selectAutoparksContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getTableSearchSelector = () =>
	createSelector(selectAutoparksContainerDomain, ({ tableSearch }) => tableSearch);

export const getRawPaginationSelector = () =>
	createSelector(selectAutoparksContainerDomain, ({ pagination }) => pagination);
